import PropTypes from 'prop-types'
import { Text } from '@artprov/design-system'
import { TEXTOS } from '../constants/textos.js'

/**
 * Banda a ancho completo con la cuenta con la que el usuario está logueado
 * (criterio 3). No se renderiza cuando todavía no hay cuenta seleccionada:
 * ese es el otro estado de la pantalla.
 */
export default function BandaCuentaConectada({ razonSocial }) {
  if (!razonSocial) return null

  // `as="output"` en lugar de un div con role="status": <output> ya tiene ese
  // rol de forma implícita y lo soportan todos los lectores de pantalla (S6819).
  // Es inline por defecto, de ahí el `block` para que ocupe el ancho completo.
  // bg-warning-50 (#FEF6E6) es el tono más claro de la escala de warning del
  // design system: a diferencia del resto de las paletas, no llega al nivel 95.
  return (
    <Text as="output" variant="body2" className="block w-full bg-warning-50 px-4 py-2.5 text-center text-tertiary-0">
      {TEXTOS.CUENTA_CONECTADA_PREFIJO} <span className="font-semibold">{razonSocial}</span>
    </Text>
  )
}

BandaCuentaConectada.propTypes = {
  razonSocial: PropTypes.string,
}
